<template>
  <v-card flat :elevation="0">
    <v-toolbar flat dense color="transparent">
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-layout row wrap>
      <v-flex align-self-center>
        <v-form class="form-height" ref="form" v-model="formValid" lazy-validation>
          <v-layout row wrap>
            <v-flex
              xs12
              sm12
              md6
              lg6
              px-2
              class="title font-weight-light grey--text text-xs-center"
            >
              <v-autocomplete
                v-if="utente.isAdmin"
                v-model="newNotaForm.nominativo"
                @change="selectUtenteHandler"
                :rules="nominativoRules"
                :items="utenti"
                :filter="selectFilter"
                clearable
                color="tree"
                hide-selected
                item-text="nominativo"
                item-value="login"
                label="Ricerca da Nome/Cognome"
                solo
              >
                <template slot="no-data">
                  <v-list-tile>
                    <v-list-tile-title>
                      <strong>Utente non esiste</strong>
                    </v-list-tile-title>
                  </v-list-tile>
                </template>
                <template slot="item" slot-scope="{ item }">
                  <v-list-tile-avatar
                    color="indigo"
                    class="headline font-weight-light white--text"
                  >{{ item.nominativo.charAt(0) }}</v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-text="item.nominativo"></v-list-tile-title>
                    <v-list-tile-sub-title v-text="item.login"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
              <v-text-field
                v-else
                label="Utente"
                :value="utente.nominativo"
                readonly
                color="tree"
                solo
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm12
              md6
              lg6
              px-2
              class="title font-weight-light grey--text text-xs-center"
            >
              <v-text-field
                v-model="newNotaForm.causale"
                :rules="descrizioneRules"
                color="blue-grey lighten-2"
                label="Causale"
                @input="selectCausaleHandler"
                clearable
                solo
              ></v-text-field>
            </v-flex>

            <v-layout v-if="renderComponent && !isSpesaAutorizzata() && !newNotaForm.causale" justify-center align-end>
              <v-flex>
                <v-subheader v-if="speseAutorizzate.length === 0" class="d-flex justify-center subheading tree--text">Effettua una richiesta di autorizzazione</v-subheader>
                <v-subheader v-else class="d-flex justify-center subheading tree--text">Seleziona la richiesta autorizzata o richiedine una nuova</v-subheader>
                <v-list one-line>
                  <v-list-tile
                    v-for="(spesaAutorizzata, k) in speseAutorizzate"
                    :key="k"
                    :inactive="spesaAutorizzata.stato != 1"
                    @click.stop="selectCausaleHandler(spesaAutorizzata.causale)"
                  >
                    <v-list-tile-action>
                      <v-icon v-if="spesaAutorizzata.stato == 1" color="success">done</v-icon>
                      <v-icon v-if="spesaAutorizzata.stato == 0" color="warning">cached</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="spesaAutorizzata.causale"></v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-content>
                      <v-list-tile-sub-title>
                        <template v-for="(spesaCategoria, ind) in getSpeseIcons(spesaAutorizzata.categorie)">
                          <v-icon :key="k + '_' + ind" right size="18" color="tree">{{spesaCategoria}}</v-icon>
                        </template>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>

            <v-layout v-if="renderComponent && !isSpesaAutorizzata() && !!newNotaForm.causale" justify-center pb-2 wrap px-2 align-center>
              <v-subheader v-if="speseAutorizzate.length === 0" class="d-flex justify-center subheading tree--text" style="flex: 100%;">Seleziona le categorie che si pensa di utilizzare</v-subheader>
              <v-flex v-for="sp in tuttiSpeseCategorie" :key="sp.id" class="pa-2" style="flex: none; display: flex; flex-direction: column;">
                <v-icon        
                  :color="categorieSelected.includes(sp.id) ? 'tree' : 'grey lighten-2'"
                  size="24"
                  @click="toggleCategoria(sp.id)"
                  >{{sp.icon}}</v-icon>
                  <span class="caption" :class="[{'tree--text' : categorieSelected.includes(sp.id),  'grey--text text--lighten-2': !categorieSelected.includes(sp.id)}]">{{sp.descrizione}}</span>
              </v-flex>
            </v-layout>

            <template v-if="renderComponent && isSpesaAutorizzata()" v-for="(spesa, ind) in newNotaForm.spese">
              <v-flex :key="ind">
                <v-flex v-if="utente.funzione === 'SAMM'" px-2>
                  <v-radio-group
                    label="Spese anticipate dal: "
                    v-model="spesa.tipo"
                    :mandatory="false"
                    row
                  >
                    <v-radio
                      class="spesa-type-check"
                      off-icon
                      on-icon
                      label="Azienda"
                      value="azienda"
                    ></v-radio>
                    <v-radio
                      class="spesa-type-check"
                      off-icon
                      on-icon
                      label="Dipendente"
                      value="dipendente"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-layout row wrap class="for-row" mt-2>
                  <v-flex px-2 xs1 sm1 md1 lg1 class="btn-row-container">
                    <v-icon color="red" @click.stop="onRemoveSpesa(ind)" :disabled="uploaded">fas fa-minus</v-icon>
                  </v-flex>
                  <v-flex px-2 xs12 sm3 md3 lg3>
                    <v-select
                      color="tree"
                      single-line
                      v-model="spesa.categoria"
                      :rules="categoriaRules"
                      :items="spesaCategorie()"
                      item-text="descrizione"
                      item-value="id"
                      label="Tipo spesa"
                      @change="onChangeCategoria($event, ind, spesa)"
                    >
                      <template slot="selection" slot-scope="{ item }">
                        <v-icon small color="indigo" left>{{ item.icon }}</v-icon>
                        {{ item.descrizione.toUpperCase() }}
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        <v-icon small color="indigo" left>{{ item.icon }}</v-icon>
                        {{ item.descrizione.toUpperCase() }}     
                      </template>
                    </v-select>
                  </v-flex>
                    <v-flex v-if="spesa.categoria && spesaMacroCat[ind] !== 'auto'" px-2 xs12 sm8 md8 lg8>
                        <v-layout row wrap >
                            <v-flex px-2 xs12 sm6 md6 lg6>
                              <v-layout row wrap>
                                <v-flex xs8 md8 px-1>
                                  <v-text-field
                                    type="number"
                                    step="0.01"
                                    autoCapitalize="none"
                                    color="tree"
                                    v-model="spesa.importo"
                                    :rules="spesa.checkAbbonamento && showAbbonamento(spesa.categoria) ? importoRulesAbb : importoRules"
                                    label="Importo"
                                    @blur="verifyImporto(spesa)"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs4 md4 px-1>
                                  <v-select
                                    color="tree"
                                    v-model="spesa.valuta"
                                    @change="verifyImporto(spesa)"
                                    :items="valute"
                                    item-text="valuta"
                                    item-value="id"
                                    label="Valuta"
                                  >
                                    <template
                                      slot="selection"
                                      slot-scope="{ item }"
                                    >{{ item.descrizione.toUpperCase() }}</template>
                                    <template
                                      slot="item"
                                      slot-scope="{ item }"
                                    >{{ item.descrizione.toUpperCase() }}</template>
                                  </v-select>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 md3>
                              <v-checkbox
                                v-if="showAbbonamento(spesa.categoria)"
                                v-model="spesa.checkAbbonamento"
                                label="Abbonamento"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex
                              v-if="spesaMacroCat[ind] !== 'auto'"
                              px-2
                              xs6
                              sm3
                              md3
                              lg3
                              class="btn-row-container"
                              style="justify-content: flex-start"
                            >
                              <input
                                type="file"
                                style="display: none"
                                :ref="'image' + ind"
                                accept="image/*, application/pdf"
                                @change="onFilePicked($event, ind)"
                              >
                              <v-btn v-if="!spesa.imageFile" @click="pickFile(ind)" color="#48586e" flat>
                                <v-icon color="#48586e">attach_file</v-icon>Scontrino
                              </v-btn>
                              <v-chip v-else outline slot="activator" color="tree" @click="showImgPrewHandler(spesa)">
                                <v-icon left style="padding: 0 10px;">fas fa-receipt</v-icon>
                                <v-tooltip right color="white" style="opacity: 1;">
                                  <span slot="activator">{{spesa.imageName.substring(0,4)}}..</span>
                                  <span>CLica per mostrare</span>
                                </v-tooltip>
                                <v-icon
                                  v-if="spesa.imageFile"
                                  style="padding: 0 10px;"
                                  right
                                  small
                                  color="error"
                                  @click.stop="onFileDettach(ind)"
                                >fas fa-trash-alt</v-icon>
                              </v-chip>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout
                  v-if="spesaMacroCat[ind] === 'auto'"
                  row
                  wrap
                  align-center
                  justify-space-between
                >
                  <v-flex px-2 xs12 sm3 md3 lg3>
                    <v-autocomplete
                      v-model="spesa.autoTarga"
                      prepend-icon="fas fa-credit-card"
                      :rules="autoTargaRules"
                      :items="targhe(spesa.categoria)"
                      :filter="selectFilter"
                      clearable
                      hide-selected
                      item-text="targa"
                      item-value="targa"
                      label="Targa"
                      color="tree"
                    >
                      <template v-if="spesa.categoria == 5" slot="no-data">
                        <v-list-tile>
                          <v-list-tile-title>
                            <strong>Targa non esiste</strong>
                          </v-list-tile-title>
                          <div class="text-xs-center">
                            <v-btn
                              round
                              color="secondary"
                              @click="showModalNewTarga(spesa)"
                            >Aggiungere nuova</v-btn>
                          </div>
                        </v-list-tile>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex px-2 xs12 sm9 md9 lg9>
                    <FormTratta
                      :koeff="koeff(spesa.categoria)"
                      :tariff="tariff(spesa.autoTarga)"
                      :rules="trattaRules"
                      @setTratta="spesa.trattaId = $event"
                      @setAutoImporto="spesa.autoImporto = $event"
                      @setTrattaTipo="spesa.trattaTipo = $event"
                    ></FormTratta>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
              </v-flex>
            </template>
          </v-layout>
          <v-layout v-if="renderComponent && isSpesaAutorizzata()" row style="justify-content: flex-start">
            <v-btn
              v-if="newNotaForm.nominativo"
              :disabled="uploaded || !newNotaForm.causale"
              dark
              color="tree"
              @click="addNewSpesaRow"
            >
              <v-icon left >fas fa-cart-plus</v-icon>
              <span>Aggiungere la spesa</span>
            </v-btn>
          </v-layout>
          <v-layout v-else row style="justify-content: flex-end">
            <v-btn
              v-if="newNotaForm.nominativo"
              :disabled="!newNotaForm.causale || categorieSelected.length === 0"
              dark
              color="orange darken-3"
              @click="richiestaAutorizzazioneHandler"
            >
              <v-icon left >fas fa-file-signature</v-icon>
              <span >Richiedere autorizzazione</span>
            </v-btn>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
    <v-card-actions v-if="renderComponent && isSpesaAutorizzata()">
      <v-layout row style="flex-direction: column">
        <v-flex
          xs12
          v-if="spesa_alb"
          class="subheading text-uppercase font-weight-medium"
        >Totale: {{this.totaleImportoAlb}} L</v-flex>
        <v-flex xs12 class="title text-uppercase font-weight-medium">Totale: {{this.totaleImporto}} €</v-flex>
      </v-layout>
      <v-spacer></v-spacer>
      <v-btn flat color="red" @click="cleanForm" class="hidden-sm-and-down">Svuota</v-btn>
      <v-btn color="#48586e" @click="beforeSaveNota" class="primary--text" :disabled="uploaded || isEmptyCaret">
        <v-icon small left color="primary">fas fa-paper-plane</v-icon>Invia
      </v-btn>
    </v-card-actions>
    <ModalNuovaTarga
      :tipo="newTargaType"
      :dialog="modalNewTarga"
      @on-save="onSaveModalNuovaTarga"
      @on-close="onCloseModalNuovaTarga"
    ></ModalNuovaTarga>         
          
    <ImagePdfPreview
      :src="imgPathSelected"
      :name="imgSelected"
      :show="imgPrev"
      @on-click-close="closeImgPrewHandler"
    ></ImagePdfPreview>
  </v-card>
</template>

<script>
import Compressor from 'compressorjs';
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import ModalNuovaTarga from "./ModalNuovaTarga.vue";
import FormTratta from "./FormTratta.vue";
import { cloneObjectJson } from "../utils/helper";
import ImagePdfPreview from "./ImagePdfPreview.vue";

const newNotaFormInit = {
  nominativo: "",
  descrizione: "",
  spese: []
};
const spesaInit = {
  tipo: "dipendente",
  categoria: null,
  importo: null,
  autoImporto: 0,
  autoTarga: null,
  trattaId: null,
  trattaTipo: "1",
  imageName: null,
  imageFile: null,
  imageUrl: null,
  checkAbbonamento: false,
  valuta: 1,
  isSpesaAuto: false
};

export default {
  name: "acc-new-nota",
  mixins: [validationMixin],
  components: { ModalNuovaTarga, FormTratta, ImagePdfPreview },
  props: {
    data: {
      type: String,
      required: true
    }
  },
  data: () => ({
    renderComponent: true,
    categorieSelected: [],
    uploaded: false,
    imgPrev: false,
    imgSelected: null,
    imgPathSelected: null,
    formValid: false,
    modalNewTarga: false,
    newTargaType: "",
    modalNewTratta: false,
    searchUtente: null,
    searchTarga: null,
    searchTratta: null,
    spesaMacroCat: [],
    formsError: false,
    newNotaForm: cloneObjectJson(newNotaFormInit),
    nominativoRules: [v => !!v || "Campo obbligatorio"],
    descrizioneRules: [v => !!v || "Campo obbligatorio"],
    categoriaRules: [v => !!v || "Campo obbligatorio"],
    importoRules: [v => !!v || "Campo obbligatorio"],
    autoTargaRules: [v => !!v || "Campo obbligatorio"],
    trattaRules: [v => !!v || "Campo obbligatorio"],
    trattaTypeRules: [v => !!v || "Campo obbligatorio"],
    valute: [
      {
        id: 1,
        descrizione: "EUR"
      },
      {
        id: 2,
        descrizione: "LEK"
      }
    ],
    spesa_alb: false,
    checkAbbonamento: false
  }),
  beforeCreate() {
    this.$store.dispatch("notaSpese/getAllTarghe");
    this.$store.dispatch("notaSpese/getAllTratte");
    this.$store.dispatch("notaSpese/getAllCitta");
    this.$store.dispatch("notaSpese/getAllVia");
  },
  created() {
    this.newNotaForm.nominativo = this.utente.login;
    this.$store.dispatch("notaSpese/getSpeseAutorizzate", {
      login: this.newNotaForm.nominativo,
      data: this.data
    });
  },
  watch: {
    data() {
      this.cleanForm()
      if (this.newNotaForm.nominativo) {
        this.$store.dispatch("notaSpese/getAnticipoAzienda", {
          login: this.newNotaForm.nominativo,
          data: this.data
        });
        this.$store.dispatch("notaSpese/getSpeseAutorizzate", {
          login: this.newNotaForm.nominativo,
          data: this.data
        });
      }
    }
  },
  computed: {
    tuttiSpeseCategorie() {
      return this.$store.getters.getPageData.categorieSpese
    },
      importoRulesAbb () {
        return [v => {
              if (v <= 50 || this.utente.funzione.toUpperCase() !== 'OPERATORE') return true;
              else
                return "Il valore massimo rimborsabile con abbonamento è di 50 euro";
        }]
      },
    trattaType() {
      return this.$store.getters.getPageData.trattaType;
    },
    speseAziendale() {
      return this.$store.getters["notaSpese/speseAziendale"];
    },
    totaleImporto() {
      let total = 0;
      let support = 0;
      this.newNotaForm.spese.forEach(sp => {
        if (sp.valuta == 2) {
          //scelto LEK
          sp.importo_convert =
            Number(this.cambioValuta(sp.importo, true).toFixed(2)) +
            Number(this.cambioValuta(sp.autoImporto, true).toFixed(2));
          var importo =
            this.cambioValuta(sp.importo, true) +
            this.cambioValuta(sp.autoImporto, true);
          support++;
        } else if (sp.valuta == 1) {
          var importo = +sp.importo + +sp.autoImporto;
        }
        total += +importo || 0;

        if (support > 0) this.spesa_alb = true;
        else this.spesa_alb = false;
      });
      return Number(total.toFixed(2));
    },
    totaleImportoAlb() {
      let total = 0;
      this.newNotaForm.spese.forEach(sp => {
        if (sp.valuta == 1) {
          sp.importo_convert =
            Number(this.cambioValuta(sp.importo, false).toFixed(2)) +
            Number(this.cambioValuta(sp.autoImporto, false).toFixed(2));
          var importo =
            this.cambioValuta(sp.importo, false) +
            this.cambioValuta(sp.autoImporto, false);
        } else if (sp.valuta == 2) {
          //scelto LEK
          var importo = +sp.importo + sp.autoImporto;
        }
        total += +importo || 0;
      });
      return Number(total.toFixed(2));
    },
    totaleImportoAziendale() {
      let total = 0;
      this.$store.getters["notaSpese/speseAziendale"].forEach(sp => {
        total += +sp.importo_da_bonificare || 0;
      });
      return total;
    },
    utente() {
      return this.$store.getters.getPageData.utente;
    },
    utenti() {
      return this.$store.getters.getPageData.listaUtenti;
    },
    tratta() {
      return this.$store.getters["notaSpese/tratte"];
    },
    targhe() {
      return val =>
        this.$store.getters["notaSpese/targhe"].filter(t => {
          return t.id_tipo_auto == 5
            ? t.id_tipo_auto == val &&
                (t.login_privato || '').split(',').includes(this.newNotaForm.nominativo)
            : t.id_tipo_auto == val;
        });
    },
    tariff() {
      return val => {
        const auto = this.$store.getters["notaSpese/targhe"].filter(tg => {
          return tg.targa === val;
        });

        return auto.length > 0 ? +auto[0]["tarif_km_aci"] || 0 : 0;
      };
    },
    koeff() {
      return val => {
        const cat = this.$store.getters.getPageData.categorieSpese.filter(
          tg => {
            return tg.id === val;
          }
        );

        return cat.length > 0 ? +cat[0]["koeff"] || 0 : 0;
      };
    },
    sceltoAbbonamento() {
      return (
        this.newNotaForm.spese.filter(function(ns) {
          return ns.checkAbbonamento === true;
        }).length > 0
      );
    },
    showAbbonamento() {
      return val => {
        const sc = this.spesaCategorie().filter(function(c) {
          return c.id === val;
        })[0];
        return sc ? Boolean(parseInt(sc[["abbonamento"]])) : false;
      };
    },
    getSpeseIcons () {
      return categorie => this.$store.getters.getPageData.categorieSpese.filter(ct => {
        return categorie && categorie.split(',').includes(ct.id)
      }).map(ct => ct.icon)
    },
    meseChiuso () {
      return this.$store.state.pageData.mesiChiusi.includes(this.data.substr(0, 7))
    },
    speseAutorizzate() {
      return this.$store.state.notaSpese.autorizzate
    },
    isEmptyCaret () {
      return this.newNotaForm.spese.length === 0
    }
  },
  methods: {
    spesaCategorie() {
      return this.$store.getters.getPageData.categorieSpese.filter(ct => {
        if (this.utente.isPreautorizzato) {
          return this.$store.getters.getPageData.categorieAutorizzate.split(',').includes(ct.id)
        } else {
          return this.spesaAutorizzataSelezionata() !== false && this.spesaAutorizzataSelezionata().categorie.split(',').includes(ct.id)
        }
      });
    },
    isSpesaAutorizzata () {
      return this.utente.isPreautorizzato || typeof this.speseAutorizzate.find(sp => sp.causale === this.newNotaForm.causale) !== 'undefined'
    },
    spesaAutorizzataSelezionata() {
      return this.speseAutorizzate.filter(sp => sp.stato == 1).find(sp => sp.causale === this.newNotaForm.causale) || false
    },
    closeImgPrewHandler() {
      this.imgPrev = false;
        this.imgSelected = null
        this.imgPathSelected = null
    },
    showImgPrewHandler(item) {
        this.imgSelected = item.imageName
        this.imgPathSelected = item.imageUrl
      this.imgPrev = true;
    },
    verifyImporto(spesa, importo) {
        const currImporto = spesa.valuta == 1 ? +spesa.importo : +spesa.importo_convert;
        const currCategoria = this.spesaCategorie().filter(sp => sp.id === spesa.categoria)[0];
        
        if (+currCategoria.max_importo > 0 && currImporto > +currCategoria.max_importo) {
            this.$swal({
                type: 'warning',
                html: `<h3>Attenzione!</h3>  La categoria ${currCategoria.descrizione.toUpperCase()} ha l'importo limitato: ${currCategoria.max_importo} Euro. <br> Sei sicuro di voler procedere con l'importo indicato?`,
                showCancelButton: true,
                cancelButtonText: 'No',
                showConfirmButton: true,
                confirmButtonText: 'Si',
            }).then(resp => {
                if (resp.dismiss === 'cancel')
                    spesa.importo = null
            })
        }
    },
    selectUtenteHandler(login) {
      if (!login) {
        this.cleanForm();
      }
      this.$store.dispatch("notaSpese/getAnticipoAzienda", {
        login: login,
        data: this.data
      });
    },
    selectFilter(item, queryText, itemText) {
      return itemText.toLowerCase().indexOf(queryText.toLowerCase() || "") > -1;
    },
    spersaValidate() {
      if (this.newNotaForm.spese.length === 0) {
        this.$notify({
          group: "warning",
          text: "Aggiungi le spese!"
        });
        return false;
      } else {
        return true;
      }
    },
    scontrinoValidate() {
      let error = false;
      for (var i = 0; i < this.newNotaForm.spese.length; i++) {
        for (var item in this.newNotaForm.spese[i]) {
          if (
            this.spesaMacroCat[i] !== "auto" &&
            (!this.newNotaForm.spese[i].imageName ||
              !this.newNotaForm.spese[i].imageFile ||
              !this.newNotaForm.spese[i].imageUrl)
          ) {
            this.$notify({
              group: "warning",
              text: "Aggiungi scontrini!"
            });
            error = true;
            break;
          }
        }
        if (error) break;
      }
      if (error) return false;
      else return true;
    },
    beforeSaveNota() {
      let $that = this;
      if (
        this.$refs.form.validate() &&
        this.spersaValidate() &&
        this.scontrinoValidate()
      ) {
        this.newNotaForm.hasAbbonamento = this.sceltoAbbonamento;
        this.$store
          .dispatch("notaSpese/existNota", {
            data: this.data,
            ...this.newNotaForm
          })
          .then(function(r) {
            var rimborsi = r.data
              .map(function(rimb) {
                return rimb.descrizione;
              })
              .join(" e ");
            if (r.stato === "success") {
              $that.saveNota();
            } else {
              $that
                .$swal({
                  html:
                    `Hai già richiesto i seguenti rimborsi (` +
                    rimborsi +
                    `) nel giorno scelto. Sei sicuro di voler procedere?`,
                  showCancelButton: true,
                  confirmButtonText: "Salva",
                  cancelButtonText: "Annulla",
                  allowOutsideClick: () => !$that.$swal.isLoading()
                })
                .then(result => {
                  if (result.value) {
                    $that.saveNota();
                  } else {
                    return false;
                  }
                });
            }
          });
      }
    },
    saveNota() {
      let $that = this;
      this.$store
        .dispatch("notaSpese/addNota", {
          data: this.data,
          ...this.newNotaForm
        })
        .then(res => {
          if (res.stato === "success") {
            this.cleanForm();
            this.$emit("on-save-nota");
            if (res.data.idRichiesta) {
              this.$swal({
                html: `<div class="font-weight-medium my-2 title firma-box">                          
                          Inserisci la password del portale per firmare e inviare a SAMM la richiesta #${
                            res.data.idRichiesta
                          }.<br />
                          <div class="font-weight-regular font-italic my-2 caption">
                            *Puoi firmare adesso oppure nella sezione 'Le mie note'.
                          </div>
                        </div>`,
                footer: !this.meseChiuso ? `<div class="checkChiusura__wrap">
                            <input id="checkChiusura" type="checkbox">
                            <label for="checkChiusura" class="tree--text title font-weight-medium">Ultima spesa del mese ${this.$moment(this.data).format('MMMM YYYY')}</label>
                          </div>` : '',
                showCancelButton: true,
                confirmButtonText: "Firma",
                cancelButtonText: "In seguito",
                input: "password",
                inputAttributes: {autocomplete: 'off'},
                inputClass: "v-text-field__slot",
                inputAttributes: {
                  autocapitalize: "off"
                },
                showLoaderOnConfirm: true,
                preConfirm: codice => {
                  return $that.$store.dispatch("notaSpese/firmaNota", {
                    data: this.data,
                    codice: codice,
                    id_richiesta: res.data.idRichiesta,
                    checkChiusura: !this.meseChiuso ? document.getElementById('checkChiusura').checked : false
                  });
                },
                allowOutsideClick: () => !$that.$swal.isLoading()
              });
            }
          }
        });
    },
    cleanForm() {
      // this.$refs.form.reset();
      this.newNotaForm = cloneObjectJson(newNotaFormInit);
      this.newNotaForm.spese = [];
      this.spesaMacroCat = [];
      this.newNotaForm.nominativo = this.utente.login;
    },
    onRemoveSpesa(indx) {
      this.newNotaForm.spese.splice(indx, 1);
      this.spesaMacroCat.splice(indx, 1);
    },
    puliziaFromSpesa(indx, newCat, mcr) {
      this.newNotaForm.spese[indx].categoria = newCat;
      this.newNotaForm.spese[indx].importo = null;
      this.newNotaForm.spese[indx].autoImporto = 0;
      this.newNotaForm.spese[indx].autoTarga = null;
      this.newNotaForm.spese[indx].trattaId = null;
      this.newNotaForm.spese[indx].trattaTipo = "1";
      this.newNotaForm.spese[indx].imageName = null;
      this.newNotaForm.spese[indx].imageFile = null;
      this.newNotaForm.spese[indx].imageUrl = null;
      this.newNotaForm.spese[indx].checkAbbonamento = false;
      this.newNotaForm.spese[indx].valuta = 1;
      this.newNotaForm.spese[indx].isSpesaAuto = mcr === "auto";
    },
    onChangeCategoria(val, indx, spesa) {
      let mcr = this.spesaCategorie().filter(ct => ct.id === val)[0]
        .macrodescrizione;

      if (this.spesaMacroCat[indx] !== mcr) {
        this.puliziaFromSpesa(indx, val, mcr);
      }
      this.spesaMacroCat[indx] = mcr;
    },
    addNewSpesaRow() {
      this.newNotaForm.spese.push(cloneObjectJson(spesaInit));
    },
    pickFile(indice) {
      this.$refs["image" + indice][0].click();
    },

//    onFilePicked_old(e, indiceSpesa) {
//      const files = e.target.files;
//      console.log('FILE', files[0]);
//      if (files[0] !== undefined) {
//        this.newNotaForm.spese[indiceSpesa].imageName = files[0].name;
//        if (
//          this.newNotaForm.spese[indiceSpesa].imageName.lastIndexOf(".") <= 0
//        ) {
//          return;
//        }
//        const fr = new FileReader();
//        fr.readAsDataURL(files[0]);
//        fr.addEventListener("load", () => {
//          this.newNotaForm.spese[indiceSpesa].imageUrl = fr.result;
//          this.newNotaForm.spese[indiceSpesa].imageFile = files[0];
//        });
//      } else {
//        this.newNotaForm.spese[indiceSpesa].imageName = "";
//        this.newNotaForm.spese[indiceSpesa].imageFile = "";
//        this.newNotaForm.spese[indiceSpesa].imageUrl = "";
//      }
//    },

    onFilePicked(e, indiceSpesa) {
        const $this = this;
        const file = e.target.files[0];
        if (!file) {
          return;
        }
        
        this.newNotaForm.spese[indiceSpesa].imageName = file.name;
        if (
          this.newNotaForm.spese[indiceSpesa].imageName.lastIndexOf(".") <= 0
        ) {
          return;
        }
        
//        if (file.size > 3145728) {
//            this.$swal({
//                  html: `<h3>Attenzione!</h3><p>La massima dimenzione del File è 3M!</p>`,
//                  showCancelButton: false,
//                  confirmButtonText: "Ok",
//                })
//            return
//        }
        const quality = file.size > 1048576 ? 0.6 : 1
      if (file !== undefined && file.type !== 'application/pdf') {
        this.uploaded = true
        new Compressor(file, {
          quality,
          success(result) {
            $this.uploaded = false
            
            const fr = new FileReader();
            fr.readAsDataURL(result);
            
            fr.addEventListener("load", () => {
              $this.newNotaForm.spese[indiceSpesa].imageUrl = fr.result;
              $this.newNotaForm.spese[indiceSpesa].imageFile = result;
            });
            
          },
          error(err) {
            $this.uploaded = false
          },
        });
        
      } else if (file.type === 'application/pdf') {
        const fr = new FileReader();
        fr.readAsDataURL(file);

        fr.addEventListener("load", () => {
          this.newNotaForm.spese[indiceSpesa].imageUrl = fr.result;
          this.newNotaForm.spese[indiceSpesa].imageFile = file;
        });
      } else {
        this.newNotaForm.spese[indiceSpesa].imageName = "";
        this.newNotaForm.spese[indiceSpesa].imageFile = "";
        this.newNotaForm.spese[indiceSpesa].imageUrl = "";
      }
    },
    onFileDettach(indiceSpesa) {
      this.$refs["image" + indiceSpesa][0].value = null;
      this.newNotaForm.spese[indiceSpesa].imageName = "";
      this.newNotaForm.spese[indiceSpesa].imageFile = "";
      this.newNotaForm.spese[indiceSpesa].imageUrl = "";
    },
    showModalNewTarga(spesa) {
      this.modalNewTarga = true;
      this.tempSpesa = spesa;
      this.newTargaType = spesa.categoria;
    },
    onCloseModalNuovaTarga() {
      this.modalNewTarga = false;
      this.tempSpesa = null;
      this.newTargaType = "";
    },
    onSaveModalNuovaTarga(dataForm) {
      this.$store
        .dispatch("notaSpese/newTarga", {
          ...dataForm,
          login_privato: dataForm.type == 5 ? this.newNotaForm.nominativo : null
        })
        .then(r => {
          if (r) {
              this.tempSpesa.autoTarga = dataForm.targa
            this.modalNewTarga = false;
              this.tempSpesa = null;
          }
        });
    },
    onCloseModalNuovaTratta() {
      this.modalNewTratta = false;
    },
    onSaveModalNuovaTratta(dataForm) {
      this.$store.dispatch("notaSpese/newTratta", dataForm).then(r => {
        if (r) {
          this.modalNewTratta = false;
        }
      });
    },
    cambioValuta(val, from_euro) {
      return from_euro
        ? val / this.$store.getters["notaSpese/valute"].body.rates.ALL
        : val * this.$store.getters["notaSpese/valute"].body.rates.ALL;
    },
    selectCausaleHandler(causa) {
      this.newNotaForm = cloneObjectJson(newNotaFormInit);
      this.newNotaForm.nominativo = this.utente.login;
      this.newNotaForm.causale = causa
      this.forceRerender()
    },   
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;
      
      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    richiestaAutorizzazioneHandler() {      
      this.$store.dispatch("notaSpese/inviaRichiestaAutorizzazione", {
        login: this.newNotaForm.nominativo,
        causale: this.newNotaForm.causale,
        categorie: this.categorieSelected.join(','),
        data: this.data
      }).then(r => {
        if (r) {
          this.selectCausaleHandler('')
          this.categorieSelected = []
        }
      })
    },
    toggleCategoria(id) {
      if(this.categorieSelected.includes(id)) {
        this.categorieSelected.splice(this.categorieSelected.indexOf(id), 1)
      } else {
        this.categorieSelected.push(id)
      }
    }
  }
};
</script>

<style lang="scss">
.form-height {
  min-height: calc(100vh - 355px);
  .v-input--radio-group {
    .v-input--radio-group__input > label {
      font-size: 1.2rem;
      padding-right: 20px;
    }
  }
  .spesa-type-check {
    .v-input--selection-controls__input {
      display: none;
    }
    .v-label {
      text-transform: uppercase;
      font-weight: 900;
      font-size: 1.5rem;
      line-height: 1;
      letter-spacing: -0.04rem;
      font-family: "Roboto", sans-serif;
      color: #00000040;
    }
    &.accent--text {
      .v-label {
        color: #01579b !important;
      }
    }
  }
  .btn-row-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

  .checkChiusura__wrap {
      display: flex;
      justify-content: center;
    input[type="checkbox"] { display: none; }

    input[type="checkbox"] + label {
      display: block;
      position: relative;
      padding-left: 35px;
      /*margin-bottom: 20px;*/
      font: 14px/20px 'Open Sans', Arial, sans-serif;
      color: #ddd;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
    }

    input[type="checkbox"] + label:last-child { margin-bottom: 0; }

    input[type="checkbox"] + label:before {
      content: '';
      display: block;
      width: 20px;
      height: 20px;
      border: 2px solid #01579b;
      position: absolute;
      left: 0;
      top: 0;
      opacity: .6;
      -webkit-transition: all .12s, border-color .08s;
      transition: all .12s, border-color .08s;
    }

    input[type="checkbox"]:checked + label:before {
      width: 10px;
      top: -5px;
      left: 5px;
      border-radius: 0;
      opacity: 1;
      border-top-color: transparent;
      border-left-color: transparent;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/FormCreaNotaSpese.vue